frappe.provide('webshop');

$(document).ready(async function() {
    if (window.location.pathname.startsWith('/app/')) return;

    if (frappe.session.user === "Guest") {
        return;
    }

    frappe.call({
        method: 'webshop.scripts.webshop_customer_select.get_navbar_select',
        callback: function(r) {
            if (!r.message) return;

            var data = r.message;
            var customers = data.customers || [];
            var selected = data.selected;

            if (!customers.length) return;

            // Create searchable select HTML
            var selectedLabel = '';
            if (selected) {
                var selectedCustomer = customers.find(function(c) { return c.value === selected; });
                selectedLabel = selectedCustomer ? selectedCustomer.label : '';
            }

            var html = `
                <li class="nav-item navbar-customer-select-container" style="margin-right: 10px; position: relative;">
                    <div class="navbar-searchable-select" style="position: relative;">
                        <input type="text" 
                               class="form-control navbar-customer-search" 
                               placeholder="${__('Search Customer...')}" 
                               value="${selectedLabel}"
                               autocomplete="off"
                               style="width: 250px; height: 32px; font-size: 13px; padding-right: 30px;">
                        <input type="hidden" class="navbar-customer-value" value="${selected || ''}">
                        <span class="select-chevron" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none; color: #888;">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </span>
                        <div class="navbar-customer-dropdown" style="display: none; position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #ddd; border-radius: 4px; max-height: 300px; overflow-y: auto; z-index: 9999; box-shadow: 0 4px 8px rgba(0,0,0,0.1); margin-top: 4px;">
                            ${customers.map(function(c) {
                                return `<div class="customer-option" data-value="${c.value}" style="padding: 8px 12px; cursor: pointer; border-bottom: 1px solid #f0f0f0; font-size: 13px;">${c.label}</div>`;
                            }).join('')}
                        </div>
                    </div>
                </li>
            `;

            $('ul.ml-auto.navbar-nav').prepend(html);

            // Setup searchable select functionality
            var $container = $('.navbar-customer-select-container');
            var $search = $container.find('.navbar-customer-search');
            var $dropdown = $container.find('.navbar-customer-dropdown');
            var $value = $container.find('.navbar-customer-value');

            // Show dropdown on focus
            $search.on('focus', function() {
                $dropdown.show();
                filterOptions($search.val());
            });

            // Filter on input
            $search.on('input', function() {
                filterOptions($(this).val());
            });

            // Hide dropdown when clicking outside
            $(document).on('click', function(e) {
                if (!$container.is(e.target) && $container.has(e.target).length === 0) {
                    $dropdown.hide();
                }
            });

            // Handle option selection
            $dropdown.on('click', '.customer-option', function() {
                var value = $(this).data('value');
                var label = $(this).text();

                $search.val(label);
                $value.val(value);
                $dropdown.hide();

                // Save to session
                frappe.call({
                    method: 'webshop.scripts.webshop_customer_select.save_selected_customer',
                    args: { customer: value },
                    callback: function() {
                        window.location.reload();
                    }
                });
            });

            // Filter function
            function filterOptions(searchText) {
                var term = searchText.toLowerCase();
                $dropdown.find('.customer-option').each(function() {
                    var text = $(this).text().toLowerCase();
                    if (text.indexOf(term) !== -1) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            }

            // Hover effect for options
            $dropdown.on('mouseenter', '.customer-option', function() {
                $(this).css('background-color', '#f5f5f5');
            }).on('mouseleave', '.customer-option', function() {
                $(this).css('background-color', '');
            });
        }
    });
});
